<template>
  <AppDialog
    :show="show"
    :title="title"
    append-to-body
    class="paid-addon-cancelation cancellation-review-data-dialog"
    @close="toggleDialog"
  >
    <div
      v-if="loading"
      class="spinner d-flex align-items-center justify-content-center p-20"
    >
      <div class="spinner-wrapper absolute">
        <span class="hi hi-spinner hi-32 text-blue" />
      </div>
    </div>
    <span class="info">
      <template v-if="isTrial">
        Your trial period isn't finished yet. Are you sure you want to end it? The following data will be removed:
      </template>
      <template v-else>
        Are you sure you want to cancel your Hubstaff Insights subscription? The following data will be removed:
      </template>
    </span>
    <div class="banner banner-lg d-flex align-items-end">
      <div class="items">
        <div class="item mb-8">
          <i class="hi hi-remove" />
          <span>
            <template v-if="usageData?.smart_notification_rule_count">
              {{ usageData.smart_notification_rule_count }}
              {{ usageData.smart_notification_rule_count | pluralize('smart notification') }}
            </template>
            <template v-else>Smart notifications</template>
          </span>
        </div>
        <div class="item mb-8">
          <i class="hi hi-remove" />
          <span>
            <template v-if="usageData?.unusual_activity_event_count">
              {{ usageData.unusual_activity_event_count }}
              {{ usageData.unusual_activity_event_count | pluralize('unusual activity event') }}
            </template>
            <template v-else>Unusual activity events</template>
          </span>
        </div>
        <div class="item mb-8">
          <i class="hi hi-remove" />
          <span>
            <template v-if="usageData?.work_time_classification_count">
              {{ usageData.work_time_classification_count }}
              {{ usageData.work_time_classification_count | pluralize('app + URL work time classification') }}
            </template>
            <template v-else>App + URL work time classifications</template>
          </span>
        </div>
        <div class="item">
          <i class="hi hi-remove" />
          <span>
            <template v-if="usageData?.member_count > 1">
              Historic trends across {{ usageData.member_count }} members: Focus time, Core work, Categories, Engagement
            </template>
            <template v-else>Historic trends across members: Focus time, Core work, Categories, Engagement</template>
          </span>
        </div>
      </div>
      <img
        class="illustration"
        :src="insightsAssets?.cancellation_flow?.illustration_red.src"
      />
    </div>
    <div class="content">
      <div class="list-title">You'll also lose access to:</div>
      <ul class="list">
        <li>Unusual activity detection</li>
        <li>Unproductive apps & URLs</li>
        <li>Team leaderboard</li>
        <li>Smart notifications</li>
        <li>Focus & meeting time</li>
        <li>Core, non-core and unproductive work</li>
      </ul>
    </div>
    <div class="modal-footer d-flex justify-content-end pt-30 flex-wrap p-0">
      <a
        class="btn btn-default"
        @click="next"
      >
        Continue cancellation
      </a>
      <a
        class="btn btn-primary"
        @click="toggleDialog"
      >
        Keep Insights
      </a>
    </div>
  </AppDialog>
</template>

<script>
import { InsightsResource } from '~/resources';
import { INSIGHTS as insightsAssets } from '~/app_constants';

export default {
  name: 'CancellationReviewDataDialog',
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
    organizationId: {
      type: Number,
      required: true,
    },
    isTrial: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    loading: true,
    usageData: null,
    insightsAssets,
  }),
  async mounted() {
    await this.fetchUsageData();
  },
  methods: {
    toggleDialog(event) {
      this.$emit('toggleDialog', this.id, false, event);
    },
    next(event) {
      this.$emit('next', this.id, event);
    },
    async fetchUsageData() {
      try {
        this.loading = true;
        const params = { organizationId: this.organizationId };
        const response = await InsightsResource.usageData(params);

        if (response) {
          this.usageData = response;
          this.loading = false;
        } else {
          throw new Error('Unable to fetch data for Insights usage.');
        }
      } catch (error) {
        this.$appMessage('Unable to fetch data for the Insights usage. Try again later.');
      }
    },
  },
};
</script>
